import { useMemo } from "react";
import {
  FlatNode,
  TreeNodeData,
} from "src/Pages/Company/OrganizationStructure/Areas/Components/EmployeeHierarchy";

const useInitialExpandState = ({
  data,
  areaId,
}: {
  data: TreeNodeData[];
  areaId: string;
}) =>
  useMemo(() => {
    const dataWithRoot = [{ ...data[0], areaId: "root" }];
    const flatNodes: FlatNode[] = [];
    const parentMap = new Map<string | null, string | null>();
    const flatNodesQueue = [...dataWithRoot];
    const fullRoute: unknown[] = [];
    const routeQueue: unknown[] = [areaId];

    while (flatNodesQueue.length > 0) {
      const currentNode = flatNodesQueue.shift();

      if (currentNode) {
        // Add current node to flat structure
        flatNodes.push({
          areaId: currentNode.areaId || "",
          name: currentNode.name,
          parentId: parentMap.get(currentNode.areaId) || null,
          hasChildren: !!(
            currentNode.children && currentNode.children.length > 0
          ),
        });

        // Process children
        if (currentNode.children) {
          // Set parent for each child
          currentNode.children.forEach((child) => {
            parentMap.set(child.areaId, currentNode.areaId);
          });

          // Add children to queue
          flatNodesQueue.push(
            ...currentNode.children.map((child) => ({
              ...child,
              areaId: child.areaId || "",
            }))
          );
        }
      }
    }

    while (routeQueue.length > 0) {
      const current = routeQueue.shift();
      const route = flatNodes.find((node) => node.areaId === current);
      if (route && route.areaId) {
        fullRoute.unshift(route.areaId);
        routeQueue.push(route.parentId);
      }
    }

    return fullRoute;
  }, [data, areaId]);

export default useInitialExpandState;
